import { forwardRef, Ref } from 'react';
import { Radio } from '@kiwicom/orbit-components';
import type { Props as OrbitProps } from '@kiwicom/orbit-components/lib/Radio/types';
import type { TranslationType } from '@kiwicom/account-consts';

type Props = Readonly<
  OrbitProps & {
    readonly label?: TranslationType;
  }
>;

const RadioButton = (props: Props, ref: Ref<HTMLInputElement>): JSX.Element => {
  return <Radio {...props} ref={ref} />;
};

export default forwardRef(RadioButton);
